<template>
    <div class="popup" v-if="isOpen" @click="clickInside">
        <div class="popup-inside">
            <button style="display: none" @click="myClose" />
            <CInput
                v-model="text"
                :label="placeholder"
                class="suggestion-input"
                ref="address_input"
                clearable
                required
                @clear="handleClear"
            />
            <div v-if="justChose && selectedSuggestion.intermediate" class="suggestion-hint">
                <label class="suggestion-hint__text">{{
                    tools.regAddrToString(selectedSuggestion.intermediate, selectedSuggestion.addressName)
                }}</label>
            </div>

            <label v-else class="suggestion-hint" />
            <div class="suggestion-labels" v-if="suggestions.length > 0">
                <div
                    v-for="suggestion in suggestions"
                    :key="suggestion"
                    class="suggestion-label"
                    @click="selectSuggestion(suggestion, true)"
                >
                    <label class="suggestion_label_name">{{ suggestion.label }}</label>
                    <label class="suggestion_label_hint">{{
                        tools.regAddrToString(suggestion.intermediate, suggestion.addressName)
                    }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash.debounce';
import tools from '@/assets/js/tools.js';
import CInput from './InputComponent.vue';

const MAX_SUGGESTIONS = 16;
const TOKEN = '27b21cb1-37db-439a-8c9a-c27cd5f06f29';

export default {
    name: 'AddressChoosePopup',

    emits: ['gis-api-call'],

    props: {
        placeholder: {
            type: String,
        },
    },
    components: {
        CInput,
    },
    data() {
        return {
            isOpen: false,
            justChose: false,
            textChanged: false,
            text: '',
            suggestResponseData: null,
            suggestions: [],
            selectedSuggestion: {},
            tools: tools,
            ipgeo: {
                latitude: null,
                longitude: null,
                region: null,
            },
            userRegion: null,
            userRegionId: null,
            callback: function () {},
        };
    },

    created() {
        this.debouncedUpdate = debounce(function () {
            this._request(this.text);
        }, 700);
    },

    async mounted() {
        // get ip
        await axios
            .get('https://api.ipgeolocation.io/ipgeo?apiKey=fc95889c2ce94d59900262967d16113c')
            .then((response) => {
                this.ipgeo.latitude = response.data.latitude;
                this.ipgeo.longitude = response.data.longitude;
            })
            .catch((err) => console.log(err));
    },

    watch: {
        text() {
            this.onInputChanged();
            this.debouncedUpdate();
        },
    },

    methods: {
        _getApiSuggestionsLinkByQuery(query) {
            if (this.ipgeo.longitude && this.ipgeo.latitude)
                query += `&location=${this.ipgeo.longitude},${this.ipgeo.latitude}`;

            return `https://catalog.api.2gis.com/3.0/suggests?q=${query}&page_size=${MAX_SUGGESTIONS}&fields=items.name_ex,items.point,items.rubrics,items.org,items.adm_div,items.routes,items.type,items.subtype,items.address,items.search_attributes.personal_priority,items.search_attributes.dgis_source_type,items.search_attributes.dgis_found_by_address,items.segment_id,items.region_id,items.locale,items.group,items.context,search_attributes,items.flags,items.has_exchange,items.ads.options&type=adm_div.region,adm_div.district_area,adm_div.city,adm_div.settlement,adm_div.district,adm_div.living_area,adm_div.division,adm_div.place,street,branch,building,road,attraction,crossroad,route,route_type,station,station.metro,user_queries,attribute,rubric,meta_rubric,org,special,coordinates,kilometer_road_sign&key=${TOKEN}&locale=ru_RU`;
        },

        async _request(userInput) {
            if (!userInput) {
                return;
            }
            
            this.$emit('gis-api-call');

            const link = this._getApiSuggestionsLinkByQuery(userInput);

            await axios
                .get(link)
                .then((response) => {
                    const suggestions = response.data.result.items;
                    if (suggestions) {
                        this._processRaw(suggestions);
                    } else {
                        this.suggestions = [];
                    }
                })
                .catch((err) => console.log(err));
        },

        _processRaw(suggestions) {
            const suggestionsObjects = suggestions.map(function (item) {
                // set region
                let region = null;
                if (item.adm_div) {
                    for (const adm_div of item.adm_div) {
                        if (adm_div.type == 'region') {
                            region = adm_div.name;
                            break;
                        }
                    }
                }

                // set label
                let label = null;
                if (item.full_name || item.address_name) label = item.full_name || item.address_name;

                // set address name
                let addressName = null;
                if (item.address_name) {
                    addressName = item.address_name;
                }

                let point = null;
                if (item.point) {
                    point = item.point;
                }

                // set all intermediate names, like district etc
                let intermediate = '';
                if (item.adm_div) {
                    intermediate = item.adm_div.map((x) => x.name).join(', ');
                }
                return {
                    label,
                    intermediate,
                    addressName,
                    region,
                    point,
                };
            });

            this.suggestions = suggestionsObjects.filter((x) => x.label || x.addressName);
        },

        selectSuggestion(suggestion, closePopup) {
            this.text = suggestion.label;
            this.selectedSuggestion = suggestion;
            this.callback(suggestion);
            if (closePopup) {
                this.clickOutside();
            }
            this.justChose = true;
        },

        handleClear() {
            this.text = '';
            this.selectedSuggestion = {};
            this.suggestions = [];
        },

        clickInside(event) {
            // Останавливаем всплытие события, чтобы клик внутри попапа не вызывал закрытие
            event.stopPropagation();
        },

        clickOutside() {
            // Вызываем закрытие попапа и удаляем слушатель событий со страницы
            this.myClose();
            document.removeEventListener('click', this.clickOutside);
        },

        myClose() {
            this.isOpen = false;
            this.selectedSuggestion = {};
        },

        myOpen(callback, suggestion) {
            this.text = '';
            this.isOpen = true;
            setTimeout(() => {
                document.addEventListener('click', this.clickOutside);
            }, 0);

            this.callback = callback;
            if (suggestion && Object.keys(suggestion).length !== 0) {
                this.selectSuggestion(suggestion);
            }
            this.suggestions = [];
            this.$nextTick(() => {
                if (this.$refs.address_input) {
                    this.$refs.address_input.$refs.input.focus();
                }
            });
            this.justChose = true;
        },

        onInputChanged() {
            this.justChose = false;
            this.textChanged = true;
            this.addressName = '';
            this.label = '';
            if (this.text == '') {
                this.selectedSuggestion = {};
                this.suggestions = [];
                this.callback({});
            }
        },
    },

    beforeUnmount() {
        this.debouncedUpdate.cancel();
    },
};
</script>

<style lang="css" scoped src="@/assets/css/address_choose_popup.css"></style>
